import './polyfills';

import { AvailableLocale, Translations } from '../language-provider/shared';
import deDETranslationMessages from '../translations/compiled/de-DE.json';
import enUSTranslationMessages from '../translations/compiled/en-US.json';
import esESTranslationMessages from '../translations/compiled/es-ES.json';
import frFRTranslationMessages from '../translations/compiled/fr-FR.json';
import itITTranslationMessages from '../translations/compiled/it-IT.json';

/**
 * `Intl` message-bucket keys — BCP‑47 tags aligned with Smartling file names under
 * `translations/` (see `translation-source-files.txt`).
 */
export const translationMessages: Translations = {
  'en-US': enUSTranslationMessages,
  'es-ES': esESTranslationMessages,
  'fr-FR': frFRTranslationMessages,
  'de-DE': deDETranslationMessages,
  'it-IT': itITTranslationMessages,
};

export const appLocales = Object.keys(translationMessages) as AvailableLocale[];
